<template lang="html">
  <v-text-field
    ref="textField"
    v-model="value.name"
    :placeholder="isTbd ? 'To Be Decided' : 'Enter ' + guestType.name + ' Name'"
    :disabled="isDisabled"
    :error-messages="errorMessages"
    :persistent-hint="persistentHint"
    :hint="hint"
    clearable
    @input="input"
  />
</template>

<script>
export default {
  name: 'GuestSelect',
  props: {
    value: {
      type: Object,
      default () {
        return {
          memberId: null,
          guestId: null,
          guestTypeId: null,
          name: null
        }
      }
    },
    errorMessages: Array,
    disabled: Boolean,
    persistentHint: Boolean,
    hint: String,
    guestTypes: Array
  },
  data: function () {
    return {
    }
  },
  computed: {
    isDisabled () {
      return !!this.disabled || this.isTbd || this.useGuestdb || !!this.guestType.error
    },
    useGuestdb () {
      return !!this.guestType.useGuestdb
    },
    isTbd () {
      return !!this.guestType.isTbd
    },
    guestType () {
      var result = this.guestTypes.find((type) => {return type.id && type.id === this.value.guestTypeId})
      if (!result) return {name: 'Unknown Guest Type', error: true}
      return result
    }
  },
  methods: {
    focus () {
      this.$refs['textField'].focus()
    },
    input (v) {
      this.$emit('input', v)
    }
  }
}
</script>
